export function assertNonNull(val, msg) {
    if (val == null)
        throw Error(msg ?? 'Expected nonnullish value.');
}
export function NonNull(val, msg) {
    assertNonNull(val, msg);
    return val;
}
